export { A as ApiExplorerIndexPage, D as DefaultApiExplorerPage } from './esm/ApiExplorerPage-DN8sGDDe.esm.js';
export { A as ApiDefinitionCard } from './esm/ApiDefinitionCard-B-gBxw4Y.esm.js';
import { r as rootRoute, a as apiDocsConfigRef, b as registerComponentRouteRef, d as defaultDefinitionWidgets } from './esm/ApiDefinitionWidget-B2Z_EBYd.esm.js';
export { A as AsyncApiDefinitionWidget, G as GraphQlDefinitionWidget, O as OpenApiDefinitionWidget, T as TrpcApiDefinitionWidget } from './esm/ApiDefinitionWidget-B2Z_EBYd.esm.js';
export { A as ApiTypeTitle, P as PlainApiDefinitionWidget } from './esm/ApiTypeTitle-Q7DWBnfV.esm.js';
export { A as ApiDefinitionDialog, C as ConsumedApisCard, H as HasApisCard, P as ProvidedApisCard } from './esm/ProvidedApisCard-DYM2U8N2.esm.js';
export { C as ConsumingComponentsCard, P as ProvidingComponentsCard } from './esm/ProvidingComponentsCard-DleuYPKR.esm.js';
import '@backstage/plugin-catalog-react';
import '@material-ui/lab/Alert';
import 'react';
import '@backstage/core-components';
import { createPlugin, createApiFactory, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import '@material-ui/core/Typography';
import 'react-router-dom';
import '@backstage/plugin-catalog';
import '@backstage/plugin-permission-react';
import '@backstage/plugin-catalog-common/alpha';
import '@material-ui/core/styles';
import '@backstage/catalog-model';
import '@material-ui/icons/Extension';
import '@material-ui/lab/ToggleButton';
import '@material-ui/core/Box';
import '@material-ui/core/Button';
import '@material-ui/core/Dialog';
import '@material-ui/core/DialogActions';
import '@material-ui/core/DialogContent';
import '@material-ui/core/DialogTitle';
import '@material-ui/core/Tab';
import '@material-ui/core/Tabs';

const apiDocsPlugin = createPlugin({
  id: "api-docs",
  routes: {
    root: rootRoute
  },
  apis: [
    createApiFactory({
      api: apiDocsConfigRef,
      deps: {},
      factory: () => {
        const definitionWidgets = defaultDefinitionWidgets();
        return {
          getApiDefinitionWidget: (apiEntity) => {
            return definitionWidgets.find((d) => d.type === apiEntity.spec.type);
          }
        };
      }
    })
  ],
  externalRoutes: {
    registerApi: registerComponentRouteRef
  }
});
const ApiExplorerPage = apiDocsPlugin.provide(
  createRoutableExtension({
    name: "ApiExplorerPage",
    component: () => import('./esm/index-DDxb-GVK.esm.js').then((m) => m.ApiExplorerIndexPage),
    mountPoint: rootRoute
  })
);
const EntityApiDefinitionCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityApiDefinitionCard",
    component: {
      lazy: () => import('./esm/index-BnvGScty.esm.js').then((m) => m.ApiDefinitionCard)
    }
  })
);
const EntityConsumedApisCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityConsumedApisCard",
    component: {
      lazy: () => import('./esm/index-BREvzWXp.esm.js').then((m) => m.ConsumedApisCard)
    }
  })
);
const EntityConsumingComponentsCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityConsumingComponentsCard",
    component: {
      lazy: () => import('./esm/index-CEoQtSjl.esm.js').then(
        (m) => m.ConsumingComponentsCard
      )
    }
  })
);
const EntityProvidedApisCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityProvidedApisCard",
    component: {
      lazy: () => import('./esm/index-BREvzWXp.esm.js').then((m) => m.ProvidedApisCard)
    }
  })
);
const EntityProvidingComponentsCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityProvidingComponentsCard",
    component: {
      lazy: () => import('./esm/index-CEoQtSjl.esm.js').then(
        (m) => m.ProvidingComponentsCard
      )
    }
  })
);
const EntityHasApisCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityHasApisCard",
    component: {
      lazy: () => import('./esm/index-BREvzWXp.esm.js').then((m) => m.HasApisCard)
    }
  })
);

export { ApiExplorerPage, EntityApiDefinitionCard, EntityConsumedApisCard, EntityConsumingComponentsCard, EntityHasApisCard, EntityProvidedApisCard, EntityProvidingComponentsCard, apiDocsConfigRef, apiDocsPlugin, defaultDefinitionWidgets, apiDocsPlugin as plugin };
//# sourceMappingURL=index.esm.js.map
